import React from "react";
import { createPortal } from "react-dom";
const Loader = ({ loading }) => {
  if (!loading) return null;
  return createPortal(
    <div className="glass-loader">
      <div className="spinner-wrapper">
        <div className="modern-spinner"></div>
      </div>
    </div>,
    document.body
  );
};

export default Loader;